import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

export default function OfflineIntercept(props) {
    const currentPath = props.currentPath || '/';
    return (
        <div className="offline-messaging">
            <header>
                <i className="cl-icon cl-icon-offline text-failure" />
                <h1>No Internet Connection</h1>
            </header>
            <p>
                It appears you have no internet connection at the moment. As a
                result, this view is not available. Please check your connection
                and try again.
            </p>
            <ul>
                <li>
                    <Link to="/" className="btn btn-primary">
                        Go to Courses view
                    </Link>
                </li>
                <li>
                    {/* TODO: Confirm this didnt' break anything */}
                    <Link
                        to={currentPath}
                        className="btn btn-primary"
                        onClick={() => window.location.reload()}
                    >
                        Refresh the page
                    </Link>
                </li>
            </ul>
        </div>
    );
}

OfflineIntercept.propTypes = {
    currentPath: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/offline_intercept.ui.jsx